import {
  CreateSessionRequest,
  CreateSessionResponse,
} from "@b2bportal/auth-api";
import { axiosInstance } from "@hopper-b2b/api";
import { startNewFeatureFlagsSession } from "@hopper-b2b/utilities";

export const createSession = async (request: CreateSessionRequest) => {
  try {
    const response = await axiosInstance.post<CreateSessionResponse>(
      "/api/v0/auth/session/commerce/create",
      request
    );
    startNewFeatureFlagsSession();
    return response.data;
  } catch (error) {
    console.error("Create session error:", error);
    throw Error("Create session error");
  }
};
